import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useLang } from "@/i18n/LanguageContext";
import { Home, CalendarDays, MapPin, Bell, Menu } from "lucide-react";

const ITEMS = [
  { key: "nav.home", icon: Home, to: "/", match: (p) => p === "/" },
  { key: "nav.itinerary", icon: CalendarDays, to: "/section/itinerary", match: (p) => p === "/section/itinerary" },
  { key: "nav.maps", icon: MapPin, to: "/section/maps", match: (p) => p === "/section/maps" },
  { key: "nav.updates", icon: Bell, to: "/", state: { scrollTo: "updates" }, match: () => false },
  { key: "nav.more", icon: Menu, to: "/more", match: (p) => p === "/more" },
];

export const BottomNav = () => {
  const { t } = useLang();
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <nav
      className="glass-nav fixed inset-x-0 bottom-0 z-50 flex items-stretch justify-around px-1 pb-safe"
      data-testid="bottom-nav"
      aria-label="Primary"
    >
      {ITEMS.map(({ key, icon: Icon, to, state, match }) => {
        const active = match(location.pathname);
        return (
          <button
            key={key}
            onClick={() => {
              if (to === "/" && !state) {
                if (location.pathname === "/") {
                  sessionStorage.setItem("maqam_home_scroll", "0");
                  window.scrollTo({ top: 0, behavior: "smooth" });
                  return;
                }
                sessionStorage.setItem("maqam_home_top", "1");
              }
              navigate(to, state ? { state } : undefined);
            }}
            data-testid={`nav-${key.split(".")[1]}`}
            aria-current={active ? "page" : undefined}
            className={`flex min-h-[58px] flex-1 flex-col items-center justify-center gap-1 py-2 transition-colors ${
              active ? "text-[#0A192F]" : "text-slate-400"
            }`}
          >
            <span
              className={`grid h-8 w-12 place-items-center rounded-full transition-colors ${
                active ? "bg-[#0A192F]/8 text-[#0A192F]" : ""
              }`}
            >
              <Icon size={21} strokeWidth={active ? 2.1 : 1.7} />
            </span>
            <span className={`text-[10px] font-semibold ${active ? "text-[#0A192F]" : "text-slate-400"}`}>
              {t(key)}
            </span>
          </button>
        );
      })}
    </nav>
  );
};
